'use strict';

export default class VariableTranslator {

    /**
     * Returns translation of key if it exists as a global variable
     *
     * @param {string} component
     * @param {string} key
     *
     * @return {string|null}
     */
    static getTranslationByKey(component, key) {

        if (window.designspark !== undefined) {
            let i18n = window.designspark[component];

            if (i18n !== undefined && i18n[key] !== undefined) {
                return i18n[key];
            }
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./src/js/translator.js